/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Low_Set_Point_TemperatureInputs */



/**
* | output |
* | --- |
* | "Minimum operating setpoint" |
*
* @param {Low_Set_Point_TemperatureInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const low_set_point_temperature = /** @type {((inputs?: Low_Set_Point_TemperatureInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Low_Set_Point_TemperatureInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Minimum operating setpoint")
	return /** @type {LocalizedString} */ ("Consigne minimum en fonctionnement")
});